<template>
    <VideoprincipalComponet />
    <div class="container">
      <div class="row">
        <div class="col-md-6">
          <SectionAComponent />
        </div>
        <div class="col-md-6">
          <SectionBComponent />
        </div>
      </div>
      <SectionCComponent />
    </div>
    <LetstalkComponent />
   
</template>

<script>
import VideoprincipalComponet from '../components/VideoprincipalComponent.vue'
import SectionAComponent from '../components/SectionAComponent.vue'
import SectionBComponent from '../components/SectionBComponent.vue'
import SectionCComponent from '../components/SectionCComponent.vue'
import LetstalkComponent from '../components/LetstalkComponent.vue'
export default {
  name: 'HomePage',
  components: {
    VideoprincipalComponet,
    SectionAComponent,
    SectionBComponent,
    SectionCComponent,
    LetstalkComponent

  },
}
</script>
<style scoped>

</style>